import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { CareHighlights } from '../components/CareHighlights';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { HowItWorks } from '../components/HowItWorks';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <>
      <HeroSection data-id="element-341" />
      <ServicesSection data-id="element-342" />
      <CareHighlights data-id="element-343" />
      <WhyChooseUs data-id="element-344" />
      <TestimonialsSection data-id="element-345" />
      <HowItWorks data-id="element-346" />
      <CTABanner data-id="element-347" />
    </>;
}